import React, { MouseEventHandler, VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  onClick: MouseEventHandler<HTMLButtonElement>;
}
const ClearButton: VFC<Props> = ({ onClick }: Props) => {
  const { iconButtonLabel } = useStyles();
  return (
    <IconButton
      size="small"
      onClick={onClick}
      classes={{ label: iconButtonLabel }}
    >
      <ClearIcon />
      <Word>{T.translate('close')}</Word>
    </IconButton>
  );
};

export default ClearButton;

const useStyles = makeStyles({
  iconButtonLabel: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const Word = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: bold;
`;
